(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // controller for agenda appointment last appointments 
    module.controller('AgendaAppointmentsLastAppointmentsController',
        ['$uibModalInstance', 'id', 'patientCaption', AgendaAppointmentsLastAppointmentsControllerFn]);

    function AgendaAppointmentsLastAppointmentsControllerFn($uibModalInstance, id, patientCaption) {
        var vm = this;
        vm.id = id;
        vm.patientCaption = patientCaption;

        vm.close = function() {
            $uibModalInstance.close();
        };
    }
})();